import { render, staticRenderFns } from "./idiom-finder.vue?vue&type=template&id=1c48bb88&scoped=true&"
import script from "./idiom-finder.vue?vue&type=script&lang=js&"
export * from "./idiom-finder.vue?vue&type=script&lang=js&"
import style0 from "./idiom-finder.vue?vue&type=style&index=0&id=1c48bb88&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48bb88",
  null
  
)

export default component.exports